<div class="signin-page-wrap height-100">
  <div class="session-form-hold mb-1">
    <div class="text-center pt-8 pb-16">
      <img src="assets/images/MT18815.gif" alt="" class="mb-05" />
    </div>
  </div>
  <div
    fxLayout="row"
    fxLayout.xs="column"
    fxLayoutWrap
    fxLayoutGap="10%"
    fxLayoutGap.sm="5%"
    fxLayoutAlign="center"
  >
    <app-login fxFlex="330px" fxFlex.xs="auto"></app-login>
    <app-register fxFlex="330px"></app-register>
  </div>
</div>
